'use client'

import { type FC, type PropsWithChildren } from 'react'
import { Configure } from 'react-instantsearch'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import { useAlgoliaUserToken, useSearchClient } from '../../../algolia'
import { useDeviceDetectorContext } from '../../../device-detector'
import {
  PRODUCT_SEARCH_HITS_PER_PAGE,
  ProductSearchVirtualWidgetSearchBox,
  useProductSearchContext,
} from '../../../product-search'

import { useStoryblokAlgoliaSearchRouting } from './hooks/useStoryblokAlgoliaSearchRouting'

export const StoryblokAlgoliaSearch: FC<
  PropsWithChildren<{ filters?: string }>
> = ({ children, filters }) => {
  const {
    productSearchConfig: { baseAlgoliaConfig },
  } = useProductSearchContext()
  const searchClient = useSearchClient()
  const { deviceType } = useDeviceDetectorContext()

  const { productsAlgoliaIndex } = baseAlgoliaConfig

  return (
    <InstantSearchNext
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      indexName={productsAlgoliaIndex}
      routing={useStoryblokAlgoliaSearchRouting()}
      searchClient={searchClient}
    >
      <Configure
        analytics={false}
        analyticsTags={['results', 'externe', 'web', deviceType]}
        clickAnalytics
        enableABTest={false}
        facetingAfterDistinct
        filters={filters}
        getRankingInfo
        hitsPerPage={PRODUCT_SEARCH_HITS_PER_PAGE}
        userToken={useAlgoliaUserToken()}
      />
      {children}
      {/*
      The search box is not part of the current page, it's located in the header.
      This virtual widget is used to preserve search parameters in the URL for routing.
      */}
      <ProductSearchVirtualWidgetSearchBox />
    </InstantSearchNext>
  )
}
